/*************************************************/
/* BANNER                                        */
/*************************************************/
export function banner() {
    const bannerPlayButtonSelector = '.banner__play';
    const bannerVideoPlayerId = 'bannerVideo';
    const bannerSelector = '.banner';
    const bannerClass = 'banner';
    const bannerPlayingClass = 'banner--playing';
    const bannerPauseableClass = 'banner--pauseable';
    const bannerPausedClass = 'banner--paused';
    const bannerVideoWrapClass = 'banner__video-wrap';

    const init = function () {
        console.log("I am initing!");
        const bannerPlayButton = document.querySelector(bannerPlayButtonSelector);
        if (bannerPlayButton != null) {
            bannerPlayButton.addEventListener('click', e => {
                e.stopPropagation();
                //Get the data for the source
                const playTriggerElement = e.target.closest(bannerPlayButtonSelector);
                const videoSources = playTriggerElement.dataset.videosources.split(',');
                const videoTypes = playTriggerElement.dataset.videotypes.split(',');

                //Stop the video and clear the sources
                let bannerVideoPlayer = document.querySelector('#' + bannerVideoPlayerId);

                //If there is no video element, because the banner is an image, create one
                if (bannerVideoPlayer == null) {
                    const bannerVideoWrap = document.createElement('div');
                    bannerVideoWrap.classList.add(bannerVideoWrapClass);
                    bannerVideoPlayer = document.createElement('video');
                    bannerVideoPlayer.id = bannerVideoPlayerId;
                    bannerVideoPlayer.setAttribute('autoplay', true);
                    bannerVideoPlayer.setAttribute('muted', true);
                    bannerVideoPlayer.setAttribute('loop', true);
                    bannerVideoPlayer.setAttribute('playsinline', true);
                    bannerVideoWrap.appendChild(bannerVideoPlayer);
                    const banner = document.querySelector(bannerSelector);
                    const bannerImage = banner.querySelector('.image-cover-wrap');
                    banner.removeChild(bannerImage);
                    banner.appendChild(bannerVideoWrap);
                }

                //Pause and remove sources
                bannerVideoPlayer.pause();
                bannerVideoPlayer.innerHTML = '';

                //Add new sources
                for (let i = 0; i < videoSources.length; i++) {
                    const sourceElement = document.createElement('source');
                    sourceElement.setAttribute('src', videoSources[i]);
                    sourceElement.setAttribute('type', videoTypes[i]);
                    bannerVideoPlayer.appendChild(sourceElement)
                }

                //Play the video
                bannerVideoPlayer.load();
                bannerVideoPlayer.muted = false;

                //Add status classes to banner
                document.querySelector(bannerSelector).classList.add(bannerPlayingClass);
                setTimeout(() => {
                    document.querySelector(bannerSelector).classList.add(bannerPauseableClass);
                    document.querySelector(bannerSelector).blur();
                }, 2000);

            });

            //Add event listener for pausing and resuming the video
            document.querySelector(bannerSelector).addEventListener('click', e => {
                let bannerElement;
                if (e.target.classList.contains(bannerClass)) {
                    bannerElement = e.target;
                } else {
                    bannerElement = e.target.closest(bannerSelector);
                }
                console.log(bannerElement);
                if (bannerElement.classList.contains(bannerPlayingClass)) {
                    const bannerVideoPlayer = document.querySelector('#' + bannerVideoPlayerId);
                    if (bannerVideoPlayer.paused) {
                        bannerVideoPlayer.play();
                        bannerElement.classList.remove(bannerPausedClass);
                    }
                    else if (bannerVideoPlayer.currentTime > 2) {
                        bannerVideoPlayer.pause();
                        bannerElement.classList.add(bannerPausedClass);

                    }
                }
            });

            if ('IntersectionObserver' in window) {
                const banner = document.querySelector(bannerSelector);
                let isPaused = false;
                const observer = new IntersectionObserver((entries, observer) => {
                    entries.forEach(entry => {
                        if (entry.target.classList.contains(bannerPlayingClass)) {
                            const video = entry.target.querySelector('#' + bannerVideoPlayerId);
                            if (entry.intersectionRatio < 0.6 && !video.paused) {
                                video.pause(); isPaused = true;
                            }
                            else if (isPaused) {
                                video.play();
                                isPaused = false
                            }
                        }
                    });
                }, { threshold: 0.6 });
                observer.observe(banner);
            }
        }

    };

    init();

}

